/** Miroir des énumérations PostgreSQL workstation_type et workstation_state. */
export const WORKSTATION_TYPES = ['fixe', 'portable', 'autre'] as const;
export type WorkstationType = (typeof WORKSTATION_TYPES)[number];

export const WORKSTATION_STATES = [
  'enService',
  'enStock',
  'enReparation',
  'retire',
] as const;
export type WorkstationState = (typeof WORKSTATION_STATES)[number];

export const EMPLOYEE_STATES = ['actif', 'parti'] as const;
export type EmployeeState = (typeof EMPLOYEE_STATES)[number];

export const WORKSTATION_TYPE_LABELS: Record<WorkstationType, string> = {
  fixe: 'Fixe',
  portable: 'Portable',
  autre: 'Autre',
};

export const WORKSTATION_STATE_LABELS: Record<WorkstationState, string> = {
  enService: 'En service',
  enStock: 'En stock',
  enReparation: 'En réparation',
  retire: 'Retiré',
};

export const EMPLOYEE_STATE_LABELS: Record<EmployeeState, string> = {
  actif: 'Actif',
  parti: 'Parti',
};

export type Tone = 'ok' | 'accent' | 'alerte' | 'danger' | 'neutre';

export const WORKSTATION_STATE_TONES: Record<WorkstationState, Tone> = {
  enService: 'ok',
  enStock: 'accent',
  enReparation: 'alerte',
  retire: 'neutre',
};

export const EMPLOYEE_STATE_TONES: Record<EmployeeState, Tone> = {
  actif: 'ok',
  parti: 'neutre',
};

/**
 * L'état d'un poste est calculé depuis le journal. Il est nul quand aucun
 * événement d'état ne subsiste : le cas est signalé tel quel, jamais remplacé
 * par un état de repli.
 */
export function workstationStateLabel(state: string | null): string {
  if (state === null) return 'État inconnu';
  return WORKSTATION_STATE_LABELS[state as WorkstationState] ?? state;
}

export function workstationStateTone(state: string | null): Tone {
  if (state === null) return 'danger';
  return WORKSTATION_STATE_TONES[state as WorkstationState] ?? 'neutre';
}
